import './styles.scss';

import React, {Component} from 'react';
import { connect } from 'react-redux';
import Countdown from 'react-countdown';

import ChatEditorAttachmentButton from '../../ChatEditorAttachmentButton/index';
import ChatEditorTextStylePopup from '../../ChatEditorTextStylePopup/index';
import ChatEditorSmilePopup from '../../ChatEditorSmilePopup/index';
import ChatEditorOwn from '../../ChatEditorOwn/index';
import ChatEditorUploadedAttachmentList from '../../ChatEditorUploadedAttachmentList/index';

import Registry from '../../../../registry/index';
import AnonymousLoginPopup from "../../AnonymousLoginPopup";

class TextInput extends Component {
    constructor(props) {
        super(props);

        if (typeof props.onSubmit == 'function') {
        	this.onSubmit = props.onSubmit;
        }

        if (typeof props.onInput == 'function') {
            this.onInput = props.onInput;
        }
        
        this.insertSmile = this.insertSmile.bind(this);

        this.onRoomSendClick = this.onRoomSendClick.bind(this);
        this.sendRoomMessage = this.sendRoomMessage.bind(this);
        
        this._onRoomMessageSendSuccess = this._onRoomMessageSendSuccess.bind(this);
        this._onRoomMessageSendError = this._onRoomMessageSendError.bind(this);

        this.state = {
            error: '',
            attachments: [],
            certified: true,
            anonymous: false,
            certification_disabled: false,
            muted_till: undefined,
        }
    }

    onSubmit() { }

    onInput() { }

    _isDisabled() {
        return this.state.anonymous || !this.state.certified || this.state.certification_disabled;
    }

    sendRoomMessage(messageText, editorInstance) {
        this.onSubmit(messageText, this);
    }

    clearEditor() {
        if(this.editorInstance) {
            this.editorInstance.clearEditor();
        }
    	this.setState({attachments: []});
    }

    value() {
    	let value = this.editorInstance ? this.editorInstance.value() : "";
    	let bbcodeAttachments = this.state.attachments.map(
    		(attachment) => '[attachment url='+encodeURIComponent(attachment.url)+' thumbnail_url='+encodeURIComponent(attachment.thumbnail_url)+'][/attachment]');
        if (bbcodeAttachments.length) {
            value += ('[attachments]' + bbcodeAttachments.join('') + '[/attachments]');
        }
    	return value;
    }

    _onRoomMessageSendSuccess() {
        this.props.dispatch({type: 'ATTACHMENTS_CLEAR'});
    }

    _onRoomMessageSendError() {
        console.log("Room message send ERROR");
    }

    onRoomSendClick() {
        if (!this._isDisabled() && this.editorInstance) {
            this.editorInstance.sendEnteredMessage();
        }
    }

    _renderTextStylePopup(context, props) {
    	if (this.textStylePopup) return;
        ChatEditorTextStylePopup.mount({
            dispatch: props.dispatch,
            editorStyle: props.editorStyle,
            anchor: this._textStylePopupIcon,
            ref: (r) => this.textStylePopup = r
        });
    }

    _renderSmileyPopup(props) {
    	if (this.smileyPopup) return;
        ChatEditorSmilePopup.mount({
            anchor: this._smileyPopupIcon,
            insertSmileFn: this.insertSmile,
            ref: (r) => this.smileyPopup = r
        });
    }

    insertSmile(smiley) {
        if(this.editorInstance) {
            this.editorInstance.insertSmile(smiley);
        }
    }

    componentDidMount() {
    	if (this.props.textStyle) {
        	this._renderTextStylePopup(this.context, this.props);
        }
        if (this.props.smiles) {
        	this._renderSmileyPopup(this.props);
        }

        if(this.editor_stub_anonymous) {

            let link_anonymous_login = this.editor_stub_anonymous.getElementsByClassName("anonymous-link-login")[0];
            if(link_anonymous_login) link_anonymous_login.addEventListener("click", () => {
                AnonymousLoginPopup.openAndSwitchTab(0);
            });

            let link_anonymous_register = this.editor_stub_anonymous.getElementsByClassName("anonymous-link-register")[0];
            if(link_anonymous_register) link_anonymous_register.addEventListener("click", () => {
                AnonymousLoginPopup.openAndSwitchTab(1);
            });

        }

        if(this.editor_stub_noncertified) {

            let link_activate_by_sms = this.editor_stub_noncertified.getElementsByClassName("link-activate-by-sms")[0];
            if(link_activate_by_sms) link_activate_by_sms.addEventListener("click", () => {
                AnonymousLoginPopup.openAndSwitchTab(5);
            });

        }

    }

    componentWillReceiveProps(nextProps) {
    	if (this.props.textStyle) {
            if (this.textStylePopup) {
                this.textStylePopup.updateStyle(nextProps);
            }

        	this._renderTextStylePopup(this.context, nextProps);
        }
        if (this.props.smiles) {
        	this._renderSmileyPopup(nextProps);
        }

        let {currentUser} = nextProps;

        this.setState({
            certified: currentUser.isCertified(),
            certification_disabled: currentUser.isCertificationDisabled() && !currentUser.isXXL(),
            anonymous: currentUser.isAnonymous(),
            muted_till: currentUser.muted_till,
        });
    }


    renderSmilesControl() {
    	let disabled = this._isDisabled();

    	return (<a className={'smile popup-opener' + (disabled ? ' disabled' : '')}
                href="#"
                ref={(smileyPopupIcon) => this._smileyPopupIcon = smileyPopupIcon}
                onClick={() => !disabled ? this.smileyPopup.open() : false}>
            </a>);
    }

    renderTextStyleControl() {
    	let disabled = this._isDisabled();

    	return (<a className={'aa popup-opener' + (disabled ? ' disabled' : '')}
                href="#"
                id="icon-text-formatting"
                ref={(textStylePopupIcon) => this._textStylePopupIcon = textStylePopupIcon}
                onClick={() => !disabled ? this.textStylePopup.open() : false}>
            </a>);
    }

    onAttachmentUpload(info) {
    	let attachments = [
    		...this.state.attachments,
    		info
    	];
    	this.setState({
    		attachments: attachments
    	});
    }

    onAttachmentUploadError(error) {
        this.setState({error})
    }

    onAttachmentDelete(info) {
        let attachments = this.state.attachments.filter(function(item) {
            return item !== info
        });

        this.setState({
            attachments: attachments
        });
    }

    renderAttachmentControl() {

    	return (<div className="block-img-go">
    		<ChatEditorAttachmentButton
                dispatch={this.props.dispatch}
                currentUser={this.props.currentUser}
                onUpload={this.onAttachmentUpload.bind(this)}
                onUploadError={this.onAttachmentUploadError.bind(this)}
            />
                            
            </div>);
    }

    insertMention(nick) {
        if(this.editorInstance) {
            this.editorInstance.insertMention(nick);
        }
    }

    countdownRenderer = ({minutes}) => {
        let lang = Registry.get('locale');
        return lang.muteCountdown(minutes);
    };

    render() {
        let lang = Registry.get('locale');

        let disabled = this._isDisabled();

        let smilesControl = this.props.smiles ?
        	this.renderSmilesControl() : null;

        let attachmentControl = this.props.attachments ?
        	this.renderAttachmentControl() : null;

        let textStyleControl = this.props.textStyle ?
        	this.renderTextStyleControl() : null;

        

        return (
        		<div className="TextInputCont">
                    <div className={'TextInput' + (disabled ? ' disabled' : '')}>
                        
                        {attachmentControl}
                        
                        <div className={'block-message-form' + (disabled ? ' disabled' : '')}>
                            {!disabled &&
                            <ChatEditorOwn
                                ref={(editor) => this.editorInstance = editor}
                                editorStyle={this.props.textStyle? this.props.editorStyle : {}}
                                sendMessageFn={this.sendRoomMessage}
                                sendNotifyFn={this.onInput}
                            />
                            }
                        </div>
                        <div
                            className="bot-chat-anonymous"
                            ref={(self) => this.editor_stub_anonymous = self}
                            style={{display: this.state.anonymous ? 'block' : 'none'}}
                            dangerouslySetInnerHTML={{__html: lang.text_editor_stub_anonymous}}
                        />
                        <div
                            className="bot-chat-noncertified"
                            ref={(self) => this.editor_stub_noncertified = self}
                            style={{display: (!this.state.certified && !this.state.anonymous && !this.state.muted_till) || this.state.certification_disabled ? 'block' : 'none'}}
                            dangerouslySetInnerHTML={{__html: this.state.certification_disabled ? lang.certification_disabled : lang.noncertified_full}}
                        />
                        {this.state.muted_till && !this.state.certified && !this.state.certification_disabled ? (
                            <div
                                className="bot-chat-noncertified"
                                ref={(self) => this.editor_stub_noncertified = self}
                            >
                                <Countdown
                                    renderer={this.countdownRenderer}
                                    date={new Date(this.state.muted_till * 1000)}
                                />
                            </div>
                        ) : null}
                        <div className="block-smile">
                            {smilesControl}
                            {textStyleControl}
                        </div>
                    </div>

                    <ChatEditorUploadedAttachmentList
                        error={this.state.error}
                    	  editorAttachments={this.state.attachments}
                        onDelete={this.onAttachmentDelete.bind(this)}
                    />
                </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        editorStyle: state.editorStyle,
        editorAttachments: state.editorAttachments,
        currentUser: state.currentUser,
        browser: state.browser
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(TextInput);
//export default TextInput;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/TextInput/index.js